import { defineComponent as _defineComponent } from 'vue'
import ListLayout from "@/components_v3/layout/ListLayout.vue";
import TableColumns from "@/components-UI/table/columns/TableColumns.vue";
import HoldConversionsTable from "@/components_v3/affiliate-balance/hold/ui/HoldConversionsTable.vue";
import { useHoldConversions } from "@/services/TablePage/hold-conversions";
import { IColumnsGroup } from "@/utils/ColumnsCreator";
import { onBeforeMount, ref, watch } from "vue";
// import DownloadButton from "@/components-UI/buttons/DownloadButton.vue";
import BaseSwitch from "@/components-UI/BaseSwitch.vue";
import { useColumnsStore } from "@/store_v3/ColumnsStore";
import { useRoute, useRouter } from "vue-router/composables";
import { useHoldSingleStore } from "@/store_v3/HoldSingleStore";
import { storeToRefs } from "pinia";
import { updateQueryString } from "@/utils/updateQueryString";


export default /*#__PURE__*/_defineComponent({
  __name: 'HoldConversions',
  setup(__props) {

const { getColumns, getDefaultColumns } = useHoldConversions();
const route = useRoute();
const router = useRouter();
const columnsStore = useColumnsStore();
const { selected: columnsSelected } = storeToRefs(columnsStore);
const { updateAllSelectedColumns } = columnsStore;
const holdSingleStore = useHoldSingleStore();
const { filters: holdSingleFilters } = storeToRefs(holdSingleStore);

const EXCLUDED_FILTER = { column: 'type', operator: 'nin', values: ['hold_expired'] };

const resolveColumnsFromQuery = (): string[] => {
    const q = route.query.columns;
    if (Array.isArray(q)) {
        const list = q.filter(Boolean) as string[];
        if (list.length) return list;
    } else if (typeof q === "string" && q.length) {
        const list = q.split(",").map((s) => s.trim()).filter(Boolean);
        if (list.length) return list;
    }
    return getDefaultColumns.value;
};

const columns = ref<IColumnsGroup[]>();
const table = ref<{ getList: () => void; exportCsv: () => Promise<void> } | null>(null);
// const exportLoading = ref(false);
const groupByConversion = ref(resolveColumnsFromQuery().includes('events'));
const excluded = ref(route.query.excluded === '1');

const syncSelectedColumns = (): void => {
    updateAllSelectedColumns(resolveColumnsFromQuery());
};

// const onExportCsv = async (): Promise<void> => {
//     if (!table.value?.exportCsv) return;
//     exportLoading.value = true;
//     try {
//         await table.value.exportCsv();
//     } finally {
//         exportLoading.value = false;
//     }
// };

const isExcludedFilterPresent = (): boolean => {
    const current = Object.values(holdSingleStore.filters) as any[];
    return current.some((f: any) => f.column === 'type' && f.operator === 'nin');
};

const addExcludedFilter = (): void => {
    if (isExcludedFilterPresent()) return;
    const current = Object.values(holdSingleStore.filters) as any[];
    holdSingleStore.updateFilters([...current, EXCLUDED_FILTER]);
};

const removeExcludedFilter = (): void => {
    if (!isExcludedFilterPresent()) return;
    const current = Object.values(holdSingleStore.filters) as any[];
    holdSingleStore.updateFilters(current.filter((f: any) => !(f.column === 'type' && f.operator === 'nin')));
};

const syncExcludedToUrl = (value: boolean): void => {
    const hasChanged = value ? route.query.excluded !== '1' : 'excluded' in route.query;
    if (!hasChanged) return;
    const query = { ...route.query };
    if (value) {
        query.excluded = '1';
    } else {
        delete query.excluded;
    }
    void router.replace({ query });
};

const syncGroupByConversionToUrl = (value: boolean): void => {
    const currentCols = columnsSelected.value.length ? columnsSelected.value : getDefaultColumns.value;
    const hasEvents = currentCols.includes('events');
    if (value === hasEvents) return;
    const nextCols = value
        ? [...currentCols, 'events']
        : currentCols.filter((c) => c !== 'events');
    updateAllSelectedColumns(nextCols);
    updateQueryString({ ...route.query, columns: nextCols });
};

watch(groupByConversion, (value) => {
    syncGroupByConversionToUrl(value);
});

watch(excluded, (value) => {
    if (value) {
        addExcludedFilter();
    } else {
        removeExcludedFilter();
    }
    syncExcludedToUrl(value);
});

watch(holdSingleFilters, () => {
    if (excluded.value && !isExcludedFilterPresent()) {
        addExcludedFilter();
    }
}, { deep: true });

onBeforeMount(() => {
    columns.value = getColumns();
    syncSelectedColumns();
    if (excluded.value) {
        addExcludedFilter();
    }
});

watch(() => route.query.columns, () => {
    syncSelectedColumns();
});

return { __sfc: true,getColumns, getDefaultColumns, route, router, columnsStore, columnsSelected, updateAllSelectedColumns, holdSingleStore, holdSingleFilters, EXCLUDED_FILTER, resolveColumnsFromQuery, columns, table, groupByConversion, excluded, syncSelectedColumns, isExcludedFilterPresent, addExcludedFilter, removeExcludedFilter, syncExcludedToUrl, syncGroupByConversionToUrl, ListLayout, TableColumns, HoldConversionsTable, BaseSwitch }
}

})